import { useAppSelector } from "redux/hooks";
import { EllipsisSX } from "theme";
import { CSSProperties } from "react";
import BreadcrumbDropdownPicker, {
  type BreadcrumbDropdownPickerOption,
} from "components/Breadcrumbs/BreadcrumbDropdownPicker";
import { selectLensEditorLens, selectLensEditorLenses } from "redux/slices/lensEditor";

export const LensEditorHomeBreadcrumb = () => {
  const clientLens = useAppSelector(selectLensEditorLens);
  const { visibleLenses, hiddenLenses } = useAppSelector(selectLensEditorLenses);

  const combinedLenses = [...visibleLenses, ...hiddenLenses];

  const options: BreadcrumbDropdownPickerOption[] = combinedLenses.map((lens) => {
    return {
      title: lens.name + (lens.hidden ? " (Hidden)" : ""),
      route: `/lens-editor/${lens.id}`,
      uniqueId: lens.id.toString(),
    };
  });

  return (
    <BreadcrumbDropdownPicker
      pendoId="breadcrumb-lens-editor-lens-picker::lensId"
      search={false}
      label={clientLens.name + (clientLens.hidden ? " (Hidden)" : "")}
      noResultsText={undefined}
      options={options}
      currentRoute={`/lens-editor/${clientLens.id}`}
      key="lenshome"
      sx={{
        ".MuiButtonBase-root": {
          width: "100%",
          ".MuiTypography-root": EllipsisSX as CSSProperties,
        },
      }}
    />
  );
};
